import { CSSProperties, useState } from "react";

interface Props {
  alt?: string;
  className?: string;
  height?: string | number;
  src?: string;
  width?: string | number;
  zoomWidth?: string | number;
}

const Image = ({
  alt = "",
  className,
  height,
  src,
  zoomWidth,
  width
}: Props) => {
  const [imageZoom, setImageZoom] = useState<string | number | undefined>(
    width
  );

  const hiddenImageStyle: CSSProperties = {
    width: 0,
    height: 0,
    position: "absolute"
  };

  const previewImage = (
    height: string | number | undefined,
    width: string | number | undefined
  ) => {
    return (
      <img
        alt="Placeholder"
        width={width}
        height={height}
        className={className || "rounded-circle"}
        src="./photo-placeholder.jpeg"
      />
    );
  };

  return src ? (
    <img
      alt={alt}
      src={src}
      onMouseEnter={() => setImageZoom(zoomWidth)}
      onMouseLeave={() => setImageZoom(width)}
      className={className || ""}
      width={width || "auto"}
      height={height || "auto"}
    />
  ) : (
    <>
      <img
        alt=""
        src={src}
        width={imageZoom || "auto"}
        height={height || "auto"}
        style={hiddenImageStyle}
      />
      {previewImage(height || "auto", width || "auto")}
    </>
  );
};

export default Image;
